.uic-loader {
    display: flex;
    height: 100%;
}

.uic-loader__bar {
    position: relative;
    background-color: transparent;
    overflow: hidden;
    // measurement
    width: 100%;
    flex: auto;
    align-self: center;

    @media #{$breakpoint_tablet} {
        height: 12px;
    }

    @media #{$breakpoint_desktop} {
        height: 15px;
    }

    &::before {
        content: "";
        display: block;
        background-color: var(--uic-color-blue4);

        animation: loading 4s ease-in-out infinite alternate;

        // measurement
        height: 100%;
        width: 100%;
    }

    &.uic-loader--light::before {
        background-color: var(--uic-color-white);
    }

    @keyframes loading {
        0.001% {
            // IE hack to prevent flickering
            transform: translateX(-98%); // IE
            transform: translateX(calc(-100% + 15px));
        }

        0% {
            transform: translateX(-98%); // IE
            transform: translateX(calc(-100% + 15px));
        }

        5% {
            transform: translateX(-98%); // IE
            transform: translateX(calc(-100% + 15px));
        }

        50% {
            transform: translateX(0);
        }

        95% {
            transform: translateX(98%); // IE
            transform: translateX(calc(100% - 15px));
        }

        100% {
            transform: translateX(98%); // IE
            transform: translateX(calc(100% - 15px));
        }
    }
}
